<template>
  <div v-if="isDateEmpty">{{ headerDate }}</div>
</template>

<script>
import Hebcal from "hebcal";
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    historyDate: Date
  },
  data() {
    return {
      headerDate: Hebcal.HDate(new Date(this.historyDate)).toString("h")
    };
  },
  computed: {
    ...mapGetters("userSearchHistory", ["getUserSearchHistory"]),
    isDateEmpty() {
      let hasSearch = false;
      this.getUserSearchHistory.forEach(sl => {
        if (
          sl.historyDate.getDate() == this.historyDate.getDate() &&
          sl.historyDate.getMonth() == this.historyDate.getMonth() &&
          sl.historyDate.getFullYear() == this.historyDate.getFullYear() &&
          sl.pin == 0
        )
          hasSearch = true;
      });
      return hasSearch;
    }
  }
};
</script>

<style lang="scss" scoped></style>
